import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
import styles from "./FileViewer.module.scss";
import { previewTableConsts } from "../constants";

const FileViewer = ({
  url,
  wrapperRef,
}: {
  url: string;
  wrapperRef: HTMLDivElement | null;
}) => {
  const [numPages, setNumPages] = useState<number | null>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };
  
  const messageComponent = (text: string) => (
    <div className={styles.pdfLoaderWrapper}>
      <p className={styles.pdfLoader}>{text}</p>
    </div>
  );

  if (!url) return messageComponent(previewTableConsts.ERROR_MESSAGE);

  return (
    <>
      <div className={styles.viewerWrapper}>
        <Document
          key={url}
          file={url}
          onLoadSuccess={onDocumentLoadSuccess}
          className={previewTableConsts.DOCUMENT_CLASS}
          error={messageComponent(previewTableConsts.ERROR_MESSAGE)}
          loading={messageComponent(previewTableConsts.LOADING_MESSAGE)}
        >
          {Array.from(new Array(numPages || 0), (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              className={previewTableConsts.PAGE_CLASS}
              scale={0.75}
              width={1080}
            />
          ))}
        </Document>
      </div>
    </>
  );
};

export default FileViewer;
